export type TestPanel = {
  key: string;            // t.ex. 'tax-account'
  titleKey: string;       // i18n-nyckel
  descriptionKey: string; // i18n-nyckel
  path: string;           // React route
};

export const TEST_PANELS: TestPanel[] = [
  {
    key: 'tax-account',
    titleKey: 'testlab.tax.title',
    descriptionKey: 'testlab.tax.desc',
    path: '/testlab/tax-account'
  },
  {
    key: 'tax-pipeline',
    titleKey: 'testlab.pipeline.title',
    descriptionKey: 'testlab.pipeline.desc',
    path: '/testlab/tax-pipeline'
  },
  {
    key: 'premium-echo',
    titleKey: 'testlab.premiumEcho.title',
    descriptionKey: 'testlab.premiumEcho.desc',
    path: '/testlab/premium-echo'
  },
  {
    key: 'full-analysis',
    titleKey: 'AuditAI Full Analysis',
    descriptionKey: 'Fullständig revision med batchning och kösystem',
    path: '/testlab/full-analysis'
  },
  {
    key: 'real-data',
    titleKey: 'AuditAI Real Data (Frontend Worker)',
    descriptionKey: 'Fullständig AI-analys med browser-worker (original)',
    path: '/testlab/real-data'
  },
  {
    key: 'real-data-backend',
    titleKey: 'AuditAI Real Data (Backend Worker)',
    descriptionKey: 'Fullständig AI-analys med Deno Deploy backend-worker (ny)',
    path: '/testlab/real-data-backend'
  }
  // fler paneler läggs till här senare
];